
define('text!pages/settings/settings_page_template.html',[],function () { return '<div class="settings-page">\r\n  <div class="page-title panel">\r\n    <p><%- _.t(\'page_titles.settings\') %></p>\r\n  </div>\r\n\r\n  <div class="settings-page-content"></div>\r\n</div>\r\n';});

